import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { calculateAge } from "../../Utils/DateUtils";
import PatientHeader from "../../components/PatientHeader/PatientHeader";
import PatientService from "../../services/PatientServices.js";
import "./Profile.css";
// Example data for a mock patient profile
// const exampleProfile = {
//   dob: "01/01/1980",
//   lastPcpVisit: "06/01/2024",
//   opportunityScore: "Score",
//   erVisits: 0,
//   admits: 0,
//   age: 44,
// };

const Profile = ({ memberId, isOpen, onClose }) => {
  // const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [patientProfile, setPatientProfile] = useState(null);
  useEffect(() => {
    if (memberId) {
      getPatientData(memberId);
    }
  }, [memberId]);
  // Mock function to "look up" a patient by ID
  const getPatientData = async (memberId) => {
    try {
      const response = await PatientService.getById(memberId);
      setPatientProfile(response.data);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };

  const getRecentAdmissions = (admissions) => {
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    return admissions.filter((admission) => {
      const admissionDate = new Date(admission.admissionDate);
      return admissionDate >= sixMonthsAgo;
    });
  };

  // Handle closing of the profile modal
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {patientProfile && (
          <PatientHeader
            fullName={`${patientProfile.firstName} ${patientProfile.lastName}`}
            dob={patientProfile.dob}
            lastPcpVisit={patientProfile.lastPcpVisit}
            opportunityScore={patientProfile.opportunityScore}
            erVisits={0}
            admits={
              patientProfile.admissions
                ? getRecentAdmissions(patientProfile.admissions).length
                : 0
            }
            age={calculateAge(patientProfile.dob)}
          />
        )}
      </DialogTitle>
      <DialogContent>
        <Divider />

        <h3 style={{ fontSize: "1rem", marginTop: "20px" }}>
          Chronic Conditions: Not registered
        </h3>
        {/* <Box
          display="flex"
          gap={2}
          flexWrap="wrap"
          justifyContent="center"
          marginBottom={4}
        >
          {[
            "Cancer",
            "CAD",
            "CHF",
            "COPD",
            "Diabetes",
            "Behavioral Health",
          ].map((condition) => (
            <Button
              key={condition}
              variant="outlined"
              style={{ fontSize: "1rem" }}
            >
              {condition}
            </Button>
          ))}
        </Box> */}

        <Divider />

        <h3 style={{ fontSize: "1rem", marginTop: "20px" }}>
          ER Visits in the past 6 months
        </h3>
        <p style={{ fontSize: "1rem" }}>
          No ER Visits found in the past 6 months.
        </p>

        <Divider />

        <h3 style={{ fontSize: "1rem", marginTop: "20px" }}>
          Hospital Admissions in the past 6 months
        </h3>
        {patientProfile &&
        patientProfile.admissions &&
        patientProfile.admissions.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Admission Date</TableCell>
                <TableCell>Facility ID</TableCell>
                <TableCell>Diagnosis Code</TableCell>
                <TableCell>Discharge Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRecentAdmissions(patientProfile.admissions).map(
                (admission, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {new Date(admission.admissionDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>{admission.facility.name}</TableCell>
                    <TableCell>{admission.diagnosisCode}</TableCell>
                    <TableCell>
                      {admission.dischargeDate
                        ? new Date(admission.dischargeDate).toLocaleDateString()
                        : "Not discharged"}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        ) : (
          <p style={{ fontSize: "1rem" }}>
            No Hospital Admissions found in the past 6 months.
          </p>
        )}

        <Divider />

        <h3 style={{ fontSize: "1rem", marginTop: "20px" }}>
          Rx Prescriptions in the past 6 months
        </h3>
        <p style={{ fontSize: "1rem" }}>
          No Rx prescriptions found in the past 6 months.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Profile;
